"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* exported Bluetooth_Device */
var Bluetooth_Device = new JS.Class({

  _success: function _success(result) {
    console.log(result);
  },

  _failure: function _failure(error) {
    console.error(error);
  },

  onConnect: function onConnect(params) {},

  settableUnits: function settableUnits() {
    return [];
  },

  initialize: function initialize(name, device_uuid, mymedic_id, max_results_count) {
    console.log("New Bluetooth Device: ", name, "  Device_UUID: ", device_uuid, "  mymedic id:", mymedic_id);

    //User might input uuid without colons
    if (device_uuid.search(/:/) == -1) {
      device_uuid = device_uuid.replace(/[a-z0-9]{2}/gi, '$&:');
      if (device_uuid.charAt(device_uuid.length - 1) == ':') {
        device_uuid = device_uuid.slice(0, -1);
      }
    }

    //Defaults
    this.scan_time = 120 * 1000; //15 seconds

    this.name = name;
    this.device_uuid = device_uuid;
    this.mymedic_id = mymedic_id;
    this.max_results_count = max_results_count;
  },

  needsPairing: function needsPairing() {
    return true;
  },

  isSupported: function isSupported() {
    return true;
  },

  allowManual: function allowManual() {
    return !this.collectsBinaryData;
  },

  waitForReadings: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(connectParams, progress) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              console.log("BT Connecting to " + this.name + ": " + this.device_uuid);
              result = {};
              _context.prev = 2;
              _context.next = 5;
              return this.getReadings();

            case 5:
              result = _context.sent;
              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              console.error(_context.t0);
              medicalSensors.stopReading(function (result) {}, function (error) {});
              result = { ok: false, error: _context.t0 };

            case 13:
              if (!result.ok) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return", result.readings);

            case 17:
              throw result.error;

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 8]]);
    }));

    function waitForReadings(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return waitForReadings;
  }(),

  disconnect: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log("BT disconnect");
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                medicalSensors.stopReading(function (result) {
                  console.log("BT Stopped");
                  resolve(result);
                }, function (error) {
                  console.error("BT disconnect error:");
                  console.error(error);
                  reject(error);
                });
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function disconnect() {
      return _ref2.apply(this, arguments);
    }

    return disconnect;
  }(),

  getReadings: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this = this;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                medicalSensors.read(_this.mymedic_id, _this.device_uuid, _this.max_results_count, function (result) {
                  console.log("BT Readings");
                  console.log(result);
                  resolve({ ok: true, readings: result });
                }, function (error) {
                  console.error("BT getReadings error:");
                  console.error(error);
                  resolve({ ok: false, error: error });
                });
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getReadings() {
      return _ref3.apply(this, arguments);
    }

    return getReadings;
  }()

});